export default {"src":"/_next/static/media/VTEX.77fe9f67.svg","height":18,"width":18};